module.exports = __webpack_public_path__ + "static/media/starship@2x.dcff1a57.jpg";